module.exports = __webpack_public_path__ + "static/media/3c.cca5e05a.jpg";